import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FintechSolutionsComponent} from './fintech-solutions.component';
import {FintechSolutionsIconsComponent} from './fintech-solutions-icons/fintech-solutions-icons.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [FintechSolutionsComponent, FintechSolutionsIconsComponent]
})
export class FintechSolutionsModule {
}



// WEBPACK FOOTER //
// ./src/app/components/fintech-solutions/fintech-solutions.module.ts